import { Grid, Tooltip, Typography } from "@mui/material";
import { useContext } from "react";
import { ProfileContext, ProfileContextPayload } from "../../../Context/ProfileDetailsContext";
import styles from "../../../Styles/ComponentStyles/ProfileStyle/AccValueTab.module.scss"
import infoIcon from '../../../assets/Images/Profile/infoIcon.svg'

const AnnuityAccValueTab = ({ accumulationPlanData }: any) => {
    const {
        finalData
    } = useContext(ProfileContext) as ProfileContextPayload

    const formatNumber = (q: any) => {
        if (!q) return q;
        q = (typeof q == "string") ? Number(q.replace(/,|$/gi, '')) : q;
        return q.toLocaleString('en-US', {
            style: 'currency',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
            currency: "usd"
        })
    }

    return (
        <>
            <Grid container className={styles.accValueTabWrapper}>
                {/* TYPICAL PLAN */}
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6} sx={{ borderRight: "1px solid #E2E8F0" }} >
                    <Grid container>
                        <Grid item xs={12} className={styles.headerContainer}>
                            <Grid container justifyContent={"space-between"} alignItems={"center"}>
                                <Grid item>
                                    <Grid container>
                                        <Grid item xs={12} className={styles.typicalPlanTxt}>
                                            Typical Plan
                                        </Grid>
                                        <Grid item xs={12} className={styles.typicalPlanSubTxt}>
                                            Traditional Plan
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <span className={styles.headerIdentifier}>BASELINE</span>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} className={styles.fieldContainer}>
                            <Grid container gap="10px">
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item className={styles.outputLabel} xs={10}>Current Age</Grid>
                                        <Grid item className={styles.outputValue} xs={2}>{finalData?.current_age || 0}</Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel} >Age at Retirement</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>{finalData?.ageAtRetirement || 0}</Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} className={styles.greyContainer}>
                            <Grid container>
                                <Grid item xs={10} className={styles.outputLabel}>Income Tax Rate (Pre-Retirement)</Grid>
                                <Grid item xs={2} className={styles.outputValue}>{finalData?.typical_plan?.tax_rate_before_retirement || 0}%</Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} className={styles.fieldContainer}>
                            <Grid container gap={"10px"}>
                                <Grid item xs={12} className={styles.sectionTitle}>
                                    Account Setup
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Annual Contributions</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            <Grid container alignItems="center" gap={"5px"}>
                                                <Grid item className={styles.fieldValue}>
                                                    {formatNumber(finalData?.typical_plan?.user_tpi_contribution_data?.[0]?.annualContribution) || "$0"}
                                                </Grid>
                                                {
                                                    finalData?.typical_plan?.user_tpi_contribution_data?.length > 1 &&
                                                    <Grid item>
                                                        <Tooltip
                                                            title={
                                                                <>
                                                                    <Grid container>
                                                                        <Grid item xs={12}>Contributions breakdown:</Grid>
                                                                        <Grid item xs={12}>
                                                                            <Grid container>
                                                                                {finalData?.typical_plan?.user_tpi_contribution_data?.map((item: any, index: number) => (
                                                                                    <Grid item xs={12} key={index}>
                                                                                        {formatNumber(item?.annualContribution || "$0")} for {index === 0 ? "first" : "next"} {item?.duration} {item?.duration > 1 ? "years" : "year"}
                                                                                    </Grid>
                                                                                ))}
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Grid>
                                                                </>
                                                            }
                                                            placement="bottom-start"
                                                            arrow
                                                            componentsProps={{
                                                                tooltip: {
                                                                    sx: {
                                                                        backgroundColor: "#3B78CE",
                                                                        color: "white",
                                                                        border: "1px solid #3B78CE",
                                                                        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                                                                        fontSize: "13px",
                                                                        fontWeight: "500",
                                                                        maxWidth: "190px",
                                                                        padding: "8px 12px",
                                                                        "& .MuiTooltip-arrow": {
                                                                            color: "#3B78CE"
                                                                        }
                                                                    }
                                                                }
                                                            }}
                                                        >
                                                            <img src={infoIcon} alt="" className={styles.infoIconForOutput} />
                                                        </Tooltip>
                                                    </Grid>
                                                }
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Starting Account Balance</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>{formatNumber(finalData?.typical_plan?.currAccountBalance) || "$0"}</Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Annual Rate of Return</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>{finalData?.typical_plan?.rateOfReturnWorking || 0}%</Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Fees</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>{finalData?.typical_plan?.percentFees || 0}%</Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Employer Match (Annual $ Contributions)</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>{formatNumber(finalData?.typical_plan?.employer_match) || 0}</Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} className={styles.lightblueContainer}>
                            <Grid container gap={"10px"}>
                                <Grid item xs={12}>
                                    <Grid container alignItems="center" gap="10px">
                                        <Grid item>
                                            <span style={{ display: "inline-block", width: "4px", height: "18px", backgroundColor: "#3B78CE", borderRadius: "2px" }} />
                                        </Grid>
                                        <Grid item>
                                            <Typography component={"span"} className={styles.sectionTitle}>Account Value at Retirement</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} className={styles.totalValueContainer}>
                                    <Grid container>
                                        <Grid item xs={10} className={`${styles.outputLabel}`}>Total contribution  (Excluding Employer Match)</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>{formatNumber(finalData?.typical_plan?.total_contribution) || "$0"}</Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} className={styles.totalValueContainer}>
                                    <Grid container>
                                        <Grid item xs={10} className={`${styles.outputLabel}`}>Total Account Value</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>{formatNumber(finalData?.typical_plan?.total_account_value) || "$0"}</Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                {/* ANNUITY - ACCUMULATION PLAN */}
                <Grid xs={12} sm={12} md={12} lg={6} xl={6}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={12} className={styles.headerContainer}>
                                    <Grid container justifyContent={"space-between"} alignItems={"center"}>
                                        <Grid item>
                                            <Grid container>
                                                <Grid item xs={12} className={styles.typicalPlanTxt}>
                                                    Annuity - Accumulation Plan
                                                </Grid>
                                                <Grid item xs={12} className={styles.typicalPlanSubTxt}>
                                                    Alternative Plan
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item>
                                            <span className={styles.headerIdentifier}>COMPARISON</span>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} className={styles.fieldContainer} paddingBottom={"146px"}>
                                    <Grid container gap="10px">
                                        <Grid item xs={12}>
                                            <Grid container>
                                                <Grid item xs={10} className={styles.outputLabel}>Current balance account</Grid>
                                                <Grid item xs={2} className={styles.outputValue}>{formatNumber(accumulationPlanData?.accumulationBalanceAccount) || "$0"}</Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Grid container>
                                                <Grid item xs={10} className={styles.outputLabel}># Years</Grid>
                                                <Grid item xs={2} className={styles.outputValue}>{accumulationPlanData?.userAccumulationYear || 0}</Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Grid container>
                                                <Grid item xs={10} className={styles.outputLabel}>Interest Rate %</Grid>
                                                <Grid item xs={2} className={styles.outputValue}>{accumulationPlanData?.userAccumulationInterestRate || 0}%</Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Grid container>
                                                <Grid item xs={10} className={styles.outputLabel}>Interest</Grid>
                                                <Grid item xs={2} className={styles.outputValue}>{formatNumber(Number(finalData?.interestAmount)) || "$0"}</Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Grid container>
                                                <Grid item xs={10} className={styles.outputLabel}>Fees %</Grid>
                                                <Grid item xs={2} className={styles.outputValue}>{accumulationPlanData?.userAccumulationAnnualFees || 0}%</Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Grid container>
                                                <Grid item xs={10} className={styles.outputLabel}>Fees</Grid>
                                                <Grid item xs={2} className={styles.outputValue}>{formatNumber(Number(finalData?.feesAmount)) || "$0"}</Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Grid container>
                                                <Grid item xs={10} className={styles.outputLabel}>Annual Contribution</Grid>
                                                <Grid item xs={2} className={styles.outputValue}>{formatNumber(accumulationPlanData?.accumulationAnnualContribution) || "$0"}</Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} className={styles.lightblueContainer}>
                            <Grid container gap={"10px"} >
                                <Grid item xs={12}>
                                    <Grid container alignItems="center" gap="10px">
                                        <Grid item>
                                            <span style={{ display: "inline-block", width: "4px", height: "18px", backgroundColor: "#3B78CE", borderRadius: "2px" }} />
                                        </Grid>
                                        <Grid item>
                                            <Typography component={"span"} className={styles.sectionTitle}>Account Value at Retirement</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} className={styles.totalValueContainer}>
                                    <Grid container>
                                        <Grid item xs={10} className={`${styles.outputLabel}`}>Total Paid</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>{formatNumber(finalData?.totalPaid) || "$0"}</Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} className={styles.totalValueContainer}>
                                    <Grid container>
                                        <Grid item xs={10} className={`${styles.outputLabel}`}>Total Account Value</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>{formatNumber(finalData?.totalAccountValue) || "$0"}</Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid >
        </>
    )
}

export default AnnuityAccValueTab
